export function roundToDecimals(value: number, decimals = 6) {
  const factor = Math.pow(10, decimals);
  return Math.floor(value * factor) / factor;
}
